import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-device-dispatch-report',
  templateUrl: './device-dispatch-report.component.html',
  styleUrls: ['./device-dispatch-report.component.scss']
})
export class DeviceDispatchReportComponent implements OnInit {

    deviceDispatchReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    serviceQueue: any = []

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
    ) {
    }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.deviceDispatchReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
        });
    }
    Reset() {
        this.deviceDispatchReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.deviceDispatchReportForm.controls["startDate"].value;
        const maxDate = new Date(this.toMinDate);
        maxDate.setMonth(maxDate.getMonth() + 12);
        this.toMaxDate = maxDate;
        const today=new Date()
        if(this.toMaxDate>today)
            this.toMaxDate=today
    }


    generateExcel() {
        debugger
        if (!this.deviceDispatchReportForm.value.startDate && !this.deviceDispatchReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.deviceDispatchReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.deviceDispatchReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.deviceDispatchReportForm.value.startDate > this.deviceDispatchReportForm.value.endDate) {
            if (this.deviceDispatchReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {
            debugger
            var filterSearch:any = {};
            var start = moment(this.deviceDispatchReportForm.value.startDate).format("YYYY/MM/DD");
            var end = moment(this.deviceDispatchReportForm.value.endDate).format("YYYY/MM/DD");

            filterSearch = { startDate: start, endDate: end };
            this.reportService.getDeviceDispatchReportPDF(filterSearch).subscribe((data)=> {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'DeviceDispatchReport.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }
        }


    }



